module.exports = __webpack_public_path__ + "static/media/campania.497d7d36.jpg";